import { VoiceAI } from './client';
import { providers } from './providers';

export interface LLMMessage {
  role: 'system' | 'user' | 'assistant';
  content: string;
}

export interface LLMOptions {
  temperature?: number;
  maxTokens?: number;
  topP?: number;
  stream?: boolean;
  [key: string]: any;
}

export interface LLMResult {
  content: string;
  usage?: {
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
  };
}

async function complete(
  messages: LLMMessage[] | string,
  model: string,
  options: LLMOptions = {}
): Promise<LLMResult | ReadableStream> {
  const client = VoiceAI.getInstance();
  const config = client.getConfig();
  
  const provider = providers.llm[model];
  if (!provider) {
    throw new Error(
      `Model "${model}" not found. Available models: ${Object.keys(providers.llm).join(', ')}\n` +
      `Need a different model? Contact founders at hello@slng.ai`
    );
  }

  const normalizedMessages = typeof messages === 'string' 
    ? [{ role: 'user' as const, content: messages }]
    : messages;

  return provider.complete(normalizedMessages, options, config);
}

export const llm = {
  async complete(messages: LLMMessage[] | string, model: string, options?: LLMOptions): Promise<LLMResult | ReadableStream> {
    return complete(messages, model, options);
  },
  
  llamaScout: (messages: LLMMessage[] | string, options?: LLMOptions) => 
    complete(messages, 'llama-4-scout', options),
  
  models: Object.keys(providers.llm),
};